import {ReactNode} from 'react';
import {
    Navigate,
    useLocation
} from "react-router-dom";
import {PlatformLoader} from "@flexinet/ui-components";
import {useAuth} from "../hooks/useAuth.ts";


export const RequireAuth = ({children}: { children: ReactNode }) => {
    const location = useLocation();
    const {
        user,
        authResolved
    } = useAuth();

    // Until getCurrentUser() settles, a falsy `user` means "not checked yet",
    // NOT "signed out". Redirecting here bounces authenticated users off their
    // own deep links on every hard load.
    if (!authResolved) {
        return <PlatformLoader/>;
    }

    if (!user) {
        // `/` is the sign-in surface in this app; `/sign-in` is not a route.
        // `state` preserves the destination, `replace` keeps the guarded URL
        // out of history so Back does not bounce.
        return <Navigate to="/" state={{from: location}} replace/>;
    }

    return children;
};
